<template>
  <v-container fluid>
    <titleBlock title="Partner Listesi"
      description="Partnerleri listeleyebilir, düzenleyebilir lisans bilgilerini değiştirebilirsiniz." />
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Ara" single-line hide-details
              @keyup.enter="getPartnerData()"></v-text-field>
          </v-col>
          <v-col>

          </v-col>
        </v-row>
      </v-card-title>
      <!--table-->
      <v-simple-table id="admin_users">
        <template style="min-height:200px" v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Id
              </th>
              <th class="text-left">
                Oluşturulma Tarihi
              </th>
              <th class="text-left">
                Firma Adı
              </th>
              <th class="text-left">
                E-posta adresi
              </th>
              <th>
                İşlemler
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id"
              :class="[user.alertPayMessage ? 'payment-alert-degree1' : 'color-default', user.alertPayMessageDouble ? 'payment-alert-degree2' : '']">
              <td>{{ user.id }}</td>
              <td class="user-dates">
                <small>
                  <div title="Panel açılış tarihi" class="user-date"><i class="fas fa-calendar-alt"></i>
                    {{ user.date }}</div>
                </small>
              </td>
              <td class="user-info">
                <div><strong>{{ user.companyTitle || 'Boş bırakılmış' }}</strong></div>
                <div><small>Yetkili : {{ user.name }} {{ user.surname }}</small></div>
                <div v-if="user.phone"><a :href="'mailto:' + user.phone"><small>Telefon : {{ user.phone
                      }}</small></a></div>
                <div v-if="!user.droplet && showDetails">
                  <div v-if="showDetails && user.ipAddress">Api: <mark>{{ user.ipAddress }}</mark></div>
                  <div v-if="showDetails && user.srvr">Server: <strong>{{ user.srvr }}</strong></div>
                  <div v-if="showDetails && user.token">Token: <input class="form-control" type="text" readonly
                      :value="user.token" /></div>
                </div>
                <div v-if="showTrials">
                  <div v-if="user.mailActivation">
                    <span class="mailActivation_true">
                      Onaylandı
                    </span>
                  </div>
                  <div v-else>
                    <span class="mailActivation_false">
                      Onaylanmadı
                    </span>
                  </div>
                </div>
              </td>
              <td class="user-email">
                <a :href="'mailto:' + user.email"><i class="far fa-envelope"></i> {{ user.email }}</a>
              </td>
              <td>
                <div v-if="user.integrationCount > 0">
                  <div v-if="!user.showIntegrations">
                    <v-btn @click="user.showIntegrations = true" depressed>
                      ${ user.integrationCount }
                    </v-btn>
                  </div>
                  <div v-else class="user-resource-list">
                    <ul>
                      <li v-for="meta in user.metas" :key="meta.id"
                        v-if="meta.resource && meta.resourceMeta && meta.resourceMeta.key == 'integration_active' && meta.value == '1'">
                        <img :title="meta.resource.name" class="fav"
                          onerror="this.src='lab.pixasoftware.com/public_html/img/pixadevelopment.gif'"
                          :src="getRLogo(meta.resource.name)" />
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="text-center">
          <v-pagination v-model="paging.page" @input="getPartnerData()" :length="paging.pages"></v-pagination>
        </div>
      </template>
      <!--table-->
      <!--dialog-->
      <div class="dialog-area" justify="center">
        <div class="dialog-area-inner">
          <v-dialog v-model="accountAddDialog" persistent width="1024">
            <template v-slot:activator="{ props }">
              <v-btn class="add-btn" color="primary" @click="openAccountAddDialog()">
                Ekle +
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span v-if="newAccountData.id" class="text-h5">Hesap Düzenle : {{ newAccountData.name
                  }}</span>
                <span v-else class="text-h5">Hesap Ekle</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Firma Adı*" v-model="newAccountData.companyTitle"
                        hint="Firma Adı" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Yetkili Kişi Adı*" v-model="newAccountData.name"
                        hint="Yetkili Kişi Adı" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Yetkili Kişi Soyadı*" v-model="newAccountData.surname"
                        hint="Yetkili Kişi Soyadı" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Yetkili Kişi Telefon*" v-model="newAccountData.phone"
                        hint="Yetkili Kişi Telefon. +90 536 635 93 41" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Hesap E-posta*" v-model="newAccountData.email"
                        hint="Bu hesap ile giriş yapılacaktır. Tüm yetkiler bu hesapta olacaktır" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-text-field label="Şifre" v-model="newAccountData.password"
                        hint="Hesaba ait şifre güvenli bir şifre olmalıdır." required></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*Zorunlu alanlardır</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="closeAccountAddDialog()">
                  Vazgeç
                </v-btn>
                <v-btn color="primary" variant="text" @click="saveAccountAddDialog()">
                  Kaydet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <!--dialog-->
    </v-card>
  </v-container>
</template>
<script>
  import { mapActions } from "vuex";
  import titleBlock from "./../../../components/layout/TitleBlock.vue";
  import moment from "moment";
  export default {
    data() {
      return {
        language: this.$root.localization.data,
        search: null,
        adUserType: 1,
        activeTab: "ALL",
        users: [],
        filter: {
          status: null,
          userType: 3,
          email: null,
          id: null,
          companyTitle: null,
          alertPayMessage: null,
          tagId: null,
          resourceNames: [],
          mailActivation: null,
          prefix: null
        },
        paging: {
          limit: 15,
          offset: 0,
          page: 0,
          pages: 0,
          count: 0,
        },
        filterDropdown: false,
        showFilterMore: false,
        showDetails: false,
        dialog: false,
        resources: [],
        resourceNames: [],
        accountAddDialog: false,
        newAccountData: {
          id:null,
          name: null,
          surname: null,
          email: null,
          phone: null,
          isActive: true,
          invoiceEmail: null,
          password: null,
          locale: 'tr',
          companyTitle: ''
        }
      };
    },
    methods: {
      ...mapActions({
        getPartners: "admin/getPartners",
      }),
      getPartnerData() {
        let self = this;
        self.getPartners({ filter: self.filter, paging: self.paging }).then(result => {
          let r = result.data;
          self.paging.count = r.count;
          self.paging.pages = r.pages;
          self.paging.page = r.page;
          self.paging.offset = r.offset;
          for (let user of r.data) {
            user.date = moment(user.creationDate).format("DD/MM/YYYY HH:mm");
            user.licenceDate = moment(user.licenceExpirationDate).format(
              "DD/MM/YYYY"
            );
            user.metas = r.metas.filter((x) => x.userId == user.id);
            user.integrationCount = 0;
            user.showIntegrations = false;
            for (let meta of user.metas) {
              meta.resource = self.resources.find(
                (x) => x.id == meta.resourceId
              );
              if (meta.resource && meta.resourceMeta && meta.resourceMeta.key == 'integration_active' && meta.value == '1') {
                user.integrationCount += 1;
              }
            }
            if (user.droplet) {
              user.droplet.updatedOn = moment(user.droplet.updatedOn).format("DD.MM.YYYY HH:mm:ss");
              if (!user.droplet.cname && user.ipAddress) {
                user.droplet.cname = user.ipAddress.replace('.pixasoftwebservices.com', '');
                user.droplet.cname = user.droplet.cname.replace('.pixasoftware.com', '');
              }
            }
          }
          self.users = r.data;
        });
      },
      openAccountAddDialog(row) {
        let self = this;
        self.accountAddDialog = true;
        if (row) {
          for (let key in row) {
            self.newAccountData[key] = row[key];
          }
        }
        else {
          self.clearAccountData();
        }
        self.infoTab = 0;
      },
      clearAccountData() {
        let self = this;
        self.newAccountData.id = null;
        self.newAccountData.name = null;
        self.newAccountData.surname = null;
        self.newAccountData.email = null;
        self.newAccountData.phone = null;
        self.newAccountData.invoiceEmail = null;
        self.newAccountData.password = null;
        self.newAccountData.locale = 'tr';
        self.newAccountData.companyTitle = '';
      },
      saveAccountAddDialog(){

      },
      closeAccountAddDialog(){
        let self = this;
        self.accountAddDialog = false;
        self.clearAccountData();
      }
    },
    components: {
      titleBlock
    },
    created() {
      this.getPartnerData();
    },
    mounted() { }
  };
</script>